import { useEffect, useState } from 'react'
import useAuthStore from '../stores/Auth'

export const useGetUserInfoWithLoading = () => {
  const [userInfo, setUserInfo] = useState(null)
  const [loading, setLoading] = useState(true) 
  const state = useAuthStore((state) => state)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await state.getUser()
        setUserInfo(result)
      } catch (error) {
        console.error('Error fetching userInfo:', error)
      } finally {
        setLoading(false) 
      }
    }

    fetchData()
  }, [state])

  return { user: userInfo, loading } 
}
